/* ==========================================================
   Filter drawer (all screen sizes)
   - "Filters" button opens the drawer
   - Live count while choosing, applies on "Show X products"
   - Options with 0 products are hidden automatically
   ========================================================== */
(function () {
  'use strict';

  var drawer, panel, form, sectionId;
  var snapshot = null;
  var lastTrigger = null;
  var timer = null;
  var controller = null;
  var busyCount = 0;
  var cache = new Map();

  function init() {
    drawer = document.querySelector('[data-fd]');
    if (!drawer) return;
    sectionId = drawer.getAttribute('data-section-id');
    bindEvents();
    setupPanel();
  }

  function setupPanel() {
    panel = drawer.querySelector('[data-fd-panel]');
    form = panel.querySelector('[data-fd-form]');
    panel.querySelectorAll('[data-fd-price]').forEach(function (g) { syncFromNumber(g); });
    layoutAll();
  }

  /* ---------------- Visibility: hide 0-count options, limit + search ---------------- */
  function layoutAll() {
    panel.querySelectorAll('[data-fd-group]').forEach(layoutGroup);
  }

  function layoutGroup(g) {
    var opts = g.querySelectorAll('[data-fd-option]');
    if (!opts.length) return; // price / range rating groups

    var limit = parseInt(g.getAttribute('data-limit'), 10) || 0;
    var search = g.querySelector('[data-fd-search]');
    var q = search ? search.value.trim().toLowerCase() : '';
    var expanded = g.classList.contains('is-expanded');
    var available = 0;
    var shown = 0;

    opts.forEach(function (o) {
      var c = o.querySelector('[data-count]');
      var input = o.querySelector('input');
      var checked = input && input.checked;
      var zero = c && parseInt(c.getAttribute('data-count'), 10) === 0 && !checked;
      var show = false;

      if (!zero) {
        available++;
        if (q) show = (o.getAttribute('data-label') || '').indexOf(q) !== -1;
        else show = checked || !limit || expanded || available <= limit;
      }
      o.hidden = !show;
      if (show) shown++;
    });

    // Hide the whole group when nothing in it has products
    g.hidden = available === 0;

    var more = g.querySelector('[data-fd-more]');
    if (more) {
      more.hidden = !!q || !limit || available <= limit;
      more.querySelector('span').textContent = more.getAttribute(expanded ? 'data-less' : 'data-more');
    }
    var empty = g.querySelector('[data-fd-noresults]');
    if (empty) empty.hidden = !(q && shown === 0);
  }

  /* ---------------- Drawer open / close ---------------- */
  function open(trigger) {
    lastTrigger = trigger || null;
    snapshot = panel.innerHTML;
    drawer.classList.add('is-open');
    panel.setAttribute('aria-modal', 'true');
    document.documentElement.classList.add('fd-lock');
    var closeBtn = panel.querySelector('.fd__close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function close(restore) {
    if (!drawer.classList.contains('is-open')) return;
    clearTimeout(timer);
    if (restore !== false && snapshot !== null) {
      panel.innerHTML = snapshot;
      setupPanel();
    }
    snapshot = null;
    drawer.classList.remove('is-open');
    panel.removeAttribute('aria-modal');
    document.documentElement.classList.remove('fd-lock');
    if (lastTrigger && document.body.contains(lastTrigger)) lastTrigger.focus();
  }

  /* ---------------- URL + fetching ---------------- */
  function buildParams() {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });

    form.querySelectorAll('[data-fd-price]').forEach(function (g) {
      var e = priceEls(g);
      if (parseFloat(e.nMin.value) <= e.min) params.delete(e.nMin.name);
      if (parseFloat(e.nMax.value) >= e.max) params.delete(e.nMax.name);
    });

    var current = new URLSearchParams(window.location.search);
    ['sort_by', 'q'].forEach(function (k) {
      if (current.get(k)) params.set(k, current.get(k));
    });
    return params;
  }

  function getDoc(params) {
    var key = params.toString();
    if (cache.has(key)) return Promise.resolve(cache.get(key));

    if (controller) controller.abort();
    controller = new AbortController();

    var p = new URLSearchParams(params);
    p.set('section_id', sectionId);

    return fetch(window.location.pathname + '?' + p.toString(), { signal: controller.signal })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (cache.size > 20) cache.delete(cache.keys().next().value);
        cache.set(key, doc);
        return doc;
      });
  }

  function setBusy(on) {
    busyCount = Math.max(0, busyCount + (on ? 1 : -1));
    drawer.classList.toggle('is-busy', busyCount > 0);
  }

  function onError(err) {
    if (err && err.name !== 'AbortError') console.error('[Filters]', err);
  }

  /* ---------------- Change → live preview of counts ---------------- */
  function onFilterChange(delay) {
    clearTimeout(timer);
    timer = setTimeout(preview, delay == null ? 250 : delay);
  }

  function preview() {
    var params = buildParams();
    setBusy(true);
    getDoc(params).then(syncFrom).catch(onError).then(function () { setBusy(false); });
  }

  // Update only counts, badges, clear buttons and result text — keeps inputs as they are
  function syncFrom(doc) {
    var fresh = doc.querySelector('[data-fd-panel]');
    if (!fresh) return;
    var map = new Map();
    panel.querySelectorAll('[data-fd-sync]').forEach(function (n) {
      map.set(n.getAttribute('data-fd-sync'), n);
    });
    fresh.querySelectorAll('[data-fd-sync]').forEach(function (n) {
      var cur = map.get(n.getAttribute('data-fd-sync'));
      if (cur) cur.replaceWith(document.importNode(n, true));
    });
    layoutAll();
  }

  function apply() {
    clearTimeout(timer);
    var params = buildParams();
    setBusy(true);
    getDoc(params)
      .then(function (doc) {
        replaceGrid(doc);
        replacePanel(doc);

        var qs = params.toString();
        window.history.pushState({ fd: true }, '', window.location.pathname + (qs ? '?' + qs : ''));
        close(false);

        var grid = document.getElementById('ProductGridContainer');
        if (grid && grid.getBoundingClientRect().top < 0) {
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(onError)
      .then(function () { setBusy(false); });
  }

  function replaceGrid(doc) {
    var newGrid = doc.getElementById('ProductGridContainer');
    var grid = document.getElementById('ProductGridContainer');
    if (newGrid && grid) grid.innerHTML = newGrid.innerHTML;
    document.dispatchEvent(new CustomEvent('collection:updated'));
  }

  function replacePanel(doc) {
    var freshPanel = doc.querySelector('[data-fd-panel]');
    if (!freshPanel) return;
    panel.innerHTML = freshPanel.innerHTML;
    setupPanel();
  }

  /* ---------------- Clear ---------------- */
  function clearGroup(g) {
    g.querySelectorAll('input[type="checkbox"]').forEach(function (i) { i.checked = false; });
    g.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = r.value === ''; });
    g.querySelectorAll('[data-fd-price]').forEach(function (p) {
      var e = priceEls(p);
      e.nMin.value = e.min;
      e.nMax.value = e.max;
      syncFromNumber(p);
    });
    var s = g.querySelector('[data-fd-search]');
    if (s) s.value = '';
    layoutGroup(g);
  }

  /* ---------------- Price slider ---------------- */
  function priceEls(g) {
    return {
      rMin: g.querySelector('[data-fd-range="min"]'),
      rMax: g.querySelector('[data-fd-range="max"]'),
      nMin: g.querySelector('[data-fd-num="min"]'),
      nMax: g.querySelector('[data-fd-num="max"]'),
      fill: g.querySelector('[data-fd-fill]'),
      min: parseFloat(g.getAttribute('data-min')) || 0,
      max: parseFloat(g.getAttribute('data-max')) || 0
    };
  }

  function paint(e) {
    var span = e.max - e.min || 1;
    var a = ((parseFloat(e.rMin.value) - e.min) / span) * 100;
    var b = ((parseFloat(e.rMax.value) - e.min) / span) * 100;
    e.fill.style.left = a + '%';
    e.fill.style.right = 100 - b + '%';
    e.rMin.style.zIndex = a > 95 ? 5 : 3;
  }

  function syncFromRange(g, which) {
    var e = priceEls(g);
    var a = parseFloat(e.rMin.value);
    var b = parseFloat(e.rMax.value);
    if (a > b) {
      if (which === 'min') { a = b; e.rMin.value = a; } else { b = a; e.rMax.value = b; }
    }
    e.nMin.value = a;
    e.nMax.value = b;
    paint(e);
  }

  function syncFromNumber(g) {
    var e = priceEls(g);
    function clamp(v, d) {
      v = parseFloat(v);
      if (isNaN(v)) v = d;
      return Math.min(e.max, Math.max(e.min, Math.round(v)));
    }
    var a = clamp(e.nMin.value, e.min);
    var b = clamp(e.nMax.value, e.max);
    if (a > b) { var t = a; a = b; b = t; }
    e.nMin.value = a; e.nMax.value = b;
    e.rMin.value = a; e.rMax.value = b;
    paint(e);
  }

  /* ---------------- Events ---------------- */
  function bindEvents() {
    document.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-fd-open]');
      if (t) { ev.preventDefault(); open(t); }
    });

    drawer.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t.closest('[data-fd-close]')) { close(); return; }

      var clear = t.closest('[data-fd-clear]');
      if (clear) { clearGroup(clear.closest('[data-fd-group]')); onFilterChange(0); return; }

      if (t.closest('[data-fd-clear-all]')) {
        form.querySelectorAll('[data-fd-group]').forEach(clearGroup);
        onFilterChange(0);
        return;
      }

      var more = t.closest('[data-fd-more]');
      if (more) {
        var g = more.closest('[data-fd-group]');
        g.classList.toggle('is-expanded');
        layoutGroup(g);
      }
    });

    drawer.addEventListener('input', function (ev) {
      var t = ev.target;
      if (t.matches('[data-fd-search]')) {
        layoutGroup(t.closest('[data-fd-group]'));
      } else if (t.matches('[data-fd-range]')) {
        syncFromRange(t.closest('[data-fd-price]'), t.getAttribute('data-fd-range'));
        onFilterChange(500);
      }
    });

    drawer.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t.matches('[data-fd-search], [data-fd-range]')) return;
      if (t.matches('[data-fd-num]')) syncFromNumber(t.closest('[data-fd-price]'));
      onFilterChange();
    });

    drawer.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var active = document.activeElement;
      if (active && active.matches && active.matches('[data-fd-num]')) {
        syncFromNumber(active.closest('[data-fd-price]'));
      }
      apply();
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    window.addEventListener('popstate', function () {
      var params = new URLSearchParams(window.location.search);
      params.delete('page');
      getDoc(params)
        .then(function (doc) { replaceGrid(doc); replacePanel(doc); })
        .catch(onError);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
